// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__vrUUK","link":"Copyright_link__+gvD0"};